import React, { useEffect, useState } from 'react';
import RouteBuilder from 'src/utils/routing/RouteBuilder';
import { useRouteBuilder } from 'src/utils/routing/RouteBuilderContext';
import { FunctionComponentReturnType } from 'src/types/sharedReact';
import { GetFrequentlyAskedQuestionsAdminResponse } from 'src/types/apiResponse';
import FrequentlyAskedQuestionForm from 'src/components/FrequentlyAskedQuestionForm/FrequentlyAskedQuestionForm';
import { getFromApi } from 'src/utils/getFromApi';
import { AxiosError } from 'axios';

function
CreateFrequentlyAskedQuestionPage(): FunctionComponentReturnType {
    const [data, setData] = useState<GetFrequentlyAskedQuestionsAdminResponse | null>(null);
    const [error, setError] = useState<AxiosError | null>(null);
    const routeBuilder: RouteBuilder = useRouteBuilder();
    const apiRoute: string = routeBuilder.api.getAllFrequentlyAskedQuestionsAdmin();

    useEffect(getFromApi(apiRoute, setData, setError), [apiRoute]);

    if (error) {
        throw error;
    }

    return data && <FrequentlyAskedQuestionForm
        frequentlyAskedQuestions={data.faqs}
    />;
}

export default CreateFrequentlyAskedQuestionPage;
